'use client';
import { useState } from 'react';
import { FaChevronRight } from 'react-icons/fa6';
import { BiBarChartAlt2 } from 'react-icons/bi';

import styles from './rankings.module.scss';
import { RankingQuoteCard } from './QuoteCard';
import { MenuList } from './MenuList';
import { useBenzingaEdge } from '@benzinga/edge';

export const StockRankings = ({ rankings, children = null }: { rankings: any; children: React.ReactNode | null }) => {
  const [index, setIndex] = useState(0);
  const { hasEdgeSubscription: hasBzEdge, isEdgeSubscriptionLoading } = useBenzingaEdge();
  const tickers = rankings?.[index]?.tickers ?? [];
  const skeletonCount = tickers.length || 8;

  const handleViewAll = () => {
    const slug = rankings?.[index]?.slug;
    if (slug) {
      window.open(`https://www.benzinga.com/screener/${slug}`, '_blank');
    } else {
      window.open('https://www.benzinga.com/screener', '_blank');
    }
  };

  return (
    <div className={styles['block-container']}>
      <div className={styles['block-header']}>
        <h2>
          <BiBarChartAlt2 className="fill-bzblue-700" size={16} />
          Benzinga Stock Rankings
        </h2>
        <div className={styles['block-header-actions']} onClick={handleViewAll}>
          View All Rankings <FaChevronRight size={12} />
        </div>
      </div>
      <div className={styles['block-content']}>
        <MenuList
          currentItem={index}
          items={
            rankings && rankings.length > 0
              ? rankings?.map((table, idx) => {
                  return {
                    label: table.title,
                    value: idx,
                  };
                })
              : []
          }
          onClick={setIndex}
        />
        <div className={styles['divider']}></div>
        {!isEdgeSubscriptionLoading && tickers.length === 0 && (
          <div className="p-2 text-gray-500">No data available</div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-4 gap-2">
          {isEdgeSubscriptionLoading
            ? Array.from({ length: skeletonCount }, (_, position) => (
                <div key={position} aria-hidden className={styles['quote-card']}>
                  <span className={styles['quote-card-position']}>{position + 1}.</span>
                  <div className="flex flex-col items-start justify-between flex-grow h-full gap-2 animate-pulse">
                    <div className="h-4 w-16 rounded bg-gray-200" />
                    <div className="h-3 w-24 rounded bg-gray-200" />
                    <div className="h-4 w-12 rounded bg-gray-200" />
                  </div>
                </div>
              ))
            : tickers.map((ticker, tickerIndex) => (
                <RankingQuoteCard
                  key={tickerIndex}
                  hideTicker={!hasBzEdge}
                  position={tickerIndex + 1}
                  ticker={ticker}
                />
              ))}
        </div>
        {children}
      </div>
    </div>
  );
};

export default StockRankings;
